
  import { defineComponent } from "vue";
  import Weather from '@/components/Weather.vue';
  import userLocationStore from "@/store/location";
  export default defineComponent({
    name: 'MapView',
    setup(){
      const locationStore = userLocationStore();

      return {
        locationStore
      }
    },
    data(){
      return{
        fillBg:'#87CEEB',
        accToken:'pk.eyJ1IjoiaWFubXVnZW55YSIsImEiOiJja3Y5Z2I2N24yOXB2MnVzM2V0YXpxbnpoIn0.JWu-qiW-iQEjgARRo9qBPw'
      }
    },
    components:{
  
    Weather,
},
  })
